import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { TextField } from 'redux-form-material-ui';

import CheckboxGroup from '../../components/CheckboxGroup';
import AlertMessage from '../../../../components/AlertMessage';
import FormFooter from '../../../../components/FormFooter';
import CNPJList from '../../components/CNPJList';
import ImageUpload from '../../components/ImageUpload';
import { BRANCHES_OPTIONS_COMPANY, branchesIds } from '../../shared/static-options';
import { required } from '../../../../utils/validators';

class LuftCompanyForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logoFile: '',
    };
  }

  _changeLogoFile = logoFile => this.setState({ logoFile })

  _addNewCompany = ({
    id, corporateName, luftBranch, cnpjList, divisions,
  }) => {
    const { onSubmit } = this.props;
    const { logoFile } = this.state;

    const processedCNPJList = cnpjList.filter(el => el.cnpj && el.cnpj !== '')
      .map(el => ({
        ...el,
        companyId: id,
      })); // remove if list contains an empty cnpj

    onSubmit({
      id,
      corporateName,
      logoFile,
      luftBranch,
      cnpjList: processedCNPJList,
      divisions,
    });
  }

  render() {
    const {
      companyData, onDismiss, onRemove, handleSubmit, errorMessage, invalid,
    } = this.props;

    return (
      <form
        onSubmit={handleSubmit(this._addNewCompany)}
      >
        <Field
          name="corporateName"
          floatingLabelText="Razão Social"
          fullWidth
          component={TextField}
          validate={required}
        />
        <FieldArray
          name="cnpjList"
          component={CNPJList}
        />
        <Field
          name="divisions"
          props={{
            label: 'Luft',
            options: BRANCHES_OPTIONS_COMPANY,
          }}
          component={CheckboxGroup}
        />
        <ImageUpload
          label="Logotipo (branco, fundo transparente)"
          imageBase64={companyData ? companyData.logo : null}
          onChange={this._changeLogoFile}
        />
        {
          errorMessage &&
          <AlertMessage
            className="LuftCompanyForm__error-message"
            error
            box
            message={errorMessage}
          />
        }
        <FormFooter
          entityName="empresa"
          invalid={invalid}
          onCancel={onDismiss}
          onRemove={onRemove ? () => { onRemove(companyData); } : null}
        />
      </form>
    );
  }
}


LuftCompanyForm.propTypes = {
  companyData: PropTypes.object,
  onSubmit: PropTypes.func,
  onDismiss: PropTypes.func,
  onRemove: PropTypes.func,
  errorMessage: PropTypes.string,
};

// Redux
const mapStateToProps = (state, ownProps) => {
  const { companyData } = ownProps;

  return companyData ?
    {
      initialValues: {
        id: companyData.id,
        corporateName: companyData.corporateName,
        luftBranch: [companyData.division],
        divisions: companyData.divisions ? companyData.divisions.split(',').map(el => parseInt(el, 10)) : [],
        cnpjList: companyData.companyCNPJ,
      },
    } :
    {
      initialValues: {
        id: '',
        corporateName: '',
        luftBranch: branchesIds.LUFT_AGRO,
        divisions: [branchesIds.LUFT_AGRO],
        cnpjList: [{}],
      },
    };
};

export default connect(mapStateToProps)(reduxForm({ form: 'luftCompany' })(LuftCompanyForm));
